import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
    IsLoggedInGuard,
    RoleHelper,
} from '@elight/client/shared/utility/auth';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full',
    },
    {
        path: 'auth',
        loadChildren: () =>
            import('@elight/client/feature/login').then(
                (m) => m.ClientFeatureLoginModule
            ),
    },
    {
        path: 'database',
        canActivate: [IsLoggedInGuard],
        data: {
            roles: {
                read: RoleHelper.viewDatabaseRoles(),
                write: RoleHelper.editDatabaseRoles(),
            },
        },
        loadChildren: () =>
            import('@elight/client/feature/database').then(
                (m) => m.ClientFeatureDatabaseModule
            ),
    },
    {
        path: 'projects',
        canActivate: [IsLoggedInGuard],
        data: {
            roles: {
                read: RoleHelper.viewProjectDataRoles(),
                write: RoleHelper.editProjectDataRoles(),
            },
        },
        loadChildren: () =>
            import('@elight/client/feature/projects').then(
                (m) => m.ClientFeatureProjectsModule
            ),
    },
    {
        path: 'users',
        canActivate: [IsLoggedInGuard],
        data: {
            roles: {
                read: RoleHelper.userManagementRoles(),
                write: RoleHelper.userManagementRoles(),
            },
        },
        loadChildren: () =>
            import('@elight/client/feature/users').then(
                (m) => m.ClientFeatureUsersModule
            ),
    },
    {
        path: 'variables',
        canActivate: [IsLoggedInGuard],
        data: {
            roles: {
                read: RoleHelper.viewVariablesRoles(),
                write: RoleHelper.editVariablesRoles(),
            },
        },
        loadChildren: () =>
            import('@elight/client/shared/feature/variables').then(
                (m) => m.ClientSharedFeatureVariablesModule
            ),
    },
    {
        path: 'proposals-templates',
        canActivate: [IsLoggedInGuard],
        data: {
            roles: {
                read: RoleHelper.uploadDocumentsRoles(),
                write: RoleHelper.uploadDocumentsRoles(),
            },
        },
        loadChildren: () =>
            import('@elight/client/feature/proposals-templates').then(
                (m) => m.ClientFeatureProposalsTemplatesModule
            ),
    },
    {
        path: '**',
        redirectTo: 'projects',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
